export default __webpack_public_path__ + "static/media/roots.33f23c55.png";